// FullscreenButton.js
import React, { useEffect, useState } from 'react';
import { Box, IconButton, Tooltip, Typography, useMediaQuery } from '@mui/material';
import FullscreenIcon from '@mui/icons-material/Fullscreen';
import FullscreenExitIcon from '@mui/icons-material/FullscreenExit';
import { useThemes } from '../Theme/theme';

const FullscreenButton = ({matches}) => {
  const [isFullscreen, setIsFullscreen] = useState(false);
  const [desktopView, setDesktopView] = useState(false);
  const { theme } = useThemes();
  const isMobile = useMediaQuery(theme.breakpoints.down('lg'));

  // alert(matches);

  const isMobileDevice = () => {
    const userAgent = navigator.userAgent.toLowerCase();
    return (
      /iphone|ipod|blackberry|iemobile|opera mini|mobi/.test(userAgent) ||
      (userAgent.includes('android') && userAgent.includes('mobile'))
    );
  };

  const toggleFullscreen = () => {
    if (isMobile) {
      const metaViewport = document.querySelector('meta[name="viewport"]');
      if (metaViewport) {
        if (!desktopView) {
          metaViewport.setAttribute('content', 'width=900');
          setDesktopView(true);
        } else {
          metaViewport.setAttribute('content', 'width=device-width, initial-scale=1');
          setDesktopView(false);
        }
      }
    } else {
      if (!document.fullscreenElement) {
        document.documentElement.requestFullscreen().catch(err =>
          console.error(`Failed to enter fullscreen mode: ${err.message}`)
        );
      } else {
        document.exitFullscreen().catch(err =>
          console.error(`Failed to exit fullscreen mode: ${err.message}`)
        );
      }
    }
  };

  useEffect(() => {
    const handleFullscreenChange = () => {
      setIsFullscreen(!!document.fullscreenElement);
    };

    document.addEventListener('fullscreenchange', handleFullscreenChange);
    handleFullscreenChange(); // Initial state

    return () => {
      document.removeEventListener('fullscreenchange', handleFullscreenChange);
    };
  }, []);

  useEffect(() => {
    const handleKeyDown = event => {
      if (event.key === 'Home') {
        event.preventDefault();
        toggleFullscreen();
      }
    };

    document.addEventListener('keydown', handleKeyDown);
    return () => document.removeEventListener('keydown', handleKeyDown);
  }, [isFullscreen, desktopView, isMobile]);

  return (
    <Tooltip
      arrow
      title={
        <Box display="flex" alignItems="center" >
          <Typography variant="body2" sx={{ fontSize: '11px' }}>
            {isFullscreen || desktopView ? 'Exit Fullscreen/Desktop' : 'Enter Fullscreen/Desktop'} / Press <kbd>Home</kbd>
          </Typography>
        </Box>
      }
    >
      <IconButton
        tabIndex={-1}
        onClick={toggleFullscreen}
        sx={{
          // boxShadow: theme.shadows[3],
          boxShadow: '0 0px 5px rgba(0, 0, 0, 0.63)',
          position: matches ? 'static' : 'fixed',
          bottom: matches ? undefined : isMobileDevice() ? 8 : 12,
          right: matches ? undefined : isMobileDevice() ? 8 : 3,
          zIndex: matches ? 'auto' : isMobileDevice() ? 999 : 9000,
          backgroundColor: theme?.palette?.TmId?.id?.toString().includes('9') ? 'gray' : '#f1ddcf',
          height:'25px',
          width:'25px'
        }}
        className='fullSceenIcon'
      >
        {(isFullscreen || desktopView) ? (
          <FullscreenExitIcon
            sx={{
              fontSize: { xs: '1.25rem', sm: '1.5rem' },
              '&:hover': { transform: 'scale(1.3)' },
              transition: 'transform 0.3s ease',
            }}
          />
        ) : (
          <FullscreenIcon
            sx={{
              fontSize: { xs: '1.25rem', sm: '16px' },
              '&:hover': { transform: 'scale(1.3)' },
              transition: 'transform 0.3s ease',
            }}
          />
        )}
      </IconButton>
    </Tooltip>
  );
};

export default FullscreenButton;
